// extracted by mini-css-extract-plugin
export default {"matches_S_container":"matchCardS1x3_matches_S_container__oZlak","matches_S":"matchCardS1x3_matches_S__x7OE4"};